import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { LoaderService } from '@core/services/loader/loader.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.css'],
})
export class LoaderComponent implements OnDestroy {
  isVisible = false;
  isFadingOut = false;

  private subscription: Subscription;

  constructor(public loaderService: LoaderService) {
    this.subscription = this.loaderService.loading$.subscribe((visible) => {
      if (visible) {
        this.isFadingOut = false;
        this.isVisible = true;
      } else {
        this.isFadingOut = true;
        setTimeout(() => {
          this.isVisible = false;
          this.isFadingOut = false;
        }, 300);
      }
    });
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
